import { Box, Section } from '@factorialco/deprecated-design-system'
import { AssessmentsQueryDocument } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import AssessmentsTable from './AssessmentsTable'

const Assessments = () => {
  const { data, loading } = useQuery(AssessmentsQueryDocument)
  if (loading) return <Loading />

  const canManageCompetencies = data?.competencies._policies.competenciesManage.can ?? false

  return (
    <ResponsivePage.NestedBody>
      <Section.FullWidth
        illustration="window-user"
        title={i18n.t('competencies_v2.title')}
        description={i18n.t('competencies_v2.description')}
        size="600"
      >
        <Box gap="s32">
          <Callout
            type="warning"
            description={i18n.t('competencies_v2.assessments.deprecation_callout.description')}
            title={i18n.t('competencies_v2.assessments.deprecation_callout.title')}
          />
          <AssessmentsTable canManageCompetencies={canManageCompetencies} />
        </Box>
      </Section.FullWidth>
    </ResponsivePage.NestedBody>
  )
}

export default Assessments
